// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2Eay1","disabled":"FileBtn_disabled__1Mae1","warn":"FileBtn_warn__3NTjB","fade":"FileBtn_fade__2BnB0"};